const fieldList = {
    name: {
        label: 'Nom',
        type: 'text',
        placeholder: 'ex : Morel',
        maxLength: 50,
        minLength: null,
    },
    firstname: {
        label: 'Prénom',
        type: 'text',
        placeholder: 'ex : Lucas',
        maxLength: 50,
        minLength: null,
    },
    phone: {
        label: 'Numéro',
        type: 'tel',
        placeholder: 'ex : +33 6 12 34 56 78',
        maxLength: 20,
        minLength: null,
    },
    email: {
        label: 'Email',
        type: 'email',
        placeholder: 'ex : utilisateur@gmail.com',
        maxLength : 320,
        minLength : null,
    },
    passwordLogin: {
        label: 'Mot de passe',
        type: 'password',
        placeholder: 'ex : MonMotDePasse123!',
        maxLength : 70,
        minLength : 8,
    },
    passwordRegister: {
        label: 'Mot de passe',
        type: 'password',
        placeholder: 'ex : MonMotDePasse123!',
        maxLength : 70,
        minLength : 8,
    },
    passwordAgain: {
        label: 'Confirmer le mot de passe',
        type: 'password',
        placeholder: 'ex : MonMotDePasse123!',
        maxLength : 70,
        minLength : 8,
    },
    address: {
        label: 'Adresse',
        type: 'text',
        placeholder: '10 Rue des Lilas, 75012 Paris',
        maxLength: 100,
        minLength: null,
    },
    company: {
        label: 'Entreprise',
        type: 'text',
        placeholder: 'La Table de Lucas',
        maxLength: 50,
        minLength: null,
    },
};

export default fieldList;